function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M40.8932 11.2253C40.4133 9.4532 39.0073 8.05633 37.2244 7.57914C33.9668 6.69324 20.9366 6.69324 20.9366 6.69324C20.9366 6.69324 7.90664 6.69324 4.64908 7.54537C2.90041 8.02225 1.46012 9.45351 0.980233 11.2253C0.123047 14.4621 0.123047 21.175 0.123047 21.175C0.123047 21.175 0.123047 27.9217 0.980233 31.1248C1.46043 32.8966 2.86611 34.2938 4.64939 34.771C7.94094 35.6569 20.9369 35.6569 20.9369 35.6569C20.9369 35.6569 33.9668 35.6569 37.2244 34.8047C39.0077 34.3279 40.4133 32.9307 40.8935 31.1589C41.7507 27.9217 41.7507 21.2091 41.7507 21.2091C41.7507 21.2091 41.785 14.4621 40.8932 11.2253Z",
  fill: "#0C1D1D",
  fillOpacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.7876 27.3767L27.623 21.175L16.7876 14.9734V27.3767Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 41.6278,
  height: 41.3671,
  fill: "white",
  transform: "translate(0.123047 0.471924)"
})));

function SvgPlay2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay2);
export default __webpack_public_path__ + "static/media/play2.711dec74.svg";
export { ForwardRef as ReactComponent };